import styled from "styled-components";

const primary = (props) => props.theme.palette.primary;
const grey = (props) => props.theme.palette.grey;
const subgrey = (props) => props.theme.palette.lightgrey;
const montserrat = (props) => props.theme.fonts.montserrat;

export const Main = styled.div`
  transition: 0.4s;
  :hover {
    cursor: pointer;
    border-radius: 4px;
    box-shadow: 6px 6px 6px ${(props) => props.theme.palette.secondary};
  }
`;

export const CardDescription = styled.div`
  min-height: 70px;
  margin: 0;

  .MuiTypography-root {
    font-family: ${montserrat};
  }

  .MuiGrid-item,
  .MuiGrid-container {
    min-height: 80px;
  }

  .MuiGrid-grid-lg-10 {
    background-color: ${subgrey} !important;
    margin: 0;
  }
`;

export const DescriptionCardIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  span,
  svg {
    color: ${primary};
    font-size: 40px;
  }
`;

export const DescriptionCardTitle = styled.div`
  color: ${primary};

  .MuiChip-root {
    margin: 0;
    width: 100%;
    justify-content: left;
    align-items: left;

    span {
      font-family: ${montserrat};
      font-size: 0.975rem;
    }
  }
`;

export const DescriptionCardContent = styled.div`
  padding: 2px 10px 5px 10px;
  font-size: 0.825rem;
  color: ${grey};

  .MuiTypography-root {
    font-size: 0.825rem;
    color: ${grey};
  }
`;
